import {
  COFFEE_GET_SETTINGS_REQUESTING,
  COFFEE_GET_SETTINGS_SUCCESS,
  COFFEE_GET_SETTINGS_ERROR,
  COFFEE_MODIFY_SETTINGS_REQUESTING,
  COFFEE_MODIFY_SETTINGS_SUCCESS,
  COFFEE_MODIFY_SETTINGS_ERROR,
  COFFEE_CHANGE_SETTINGS,
  COFFEE_CLOSE_SNACK_MESSAGE
} from "./constants";

import { AUTH_LOGOUT_SUCCESS } from "../auth/reducer";
import moment from "moment";

const initialState = {
  activated: false,
  reminderTime: moment(),
  error: null,
  isSnackMessage: false,
  snackMessage: "",
  tabSelected: 0,
  requesting: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case COFFEE_MODIFY_SETTINGS_REQUESTING:
    case COFFEE_GET_SETTINGS_REQUESTING:
      return {
        ...state,
        requesting: true
      };

    case COFFEE_MODIFY_SETTINGS_ERROR:
    case COFFEE_GET_SETTINGS_ERROR:
      return {
        ...state,
        error: action.payload,
        requesting: false
      };

    case COFFEE_GET_SETTINGS_SUCCESS: {
      const { activated, reminderTime } = action.payload;
      return { ...state, activated, reminderTime, requesting: false };
    }

    case COFFEE_MODIFY_SETTINGS_SUCCESS:
      return {
        ...state,
        isSnackMessage: true,
        snackMessage: "Paramètres modifiés avec succès !",
        requesting: false
      };

    case COFFEE_CHANGE_SETTINGS: {
      return {
        ...state,
        ...action.payload
      };
    }

    case COFFEE_CLOSE_SNACK_MESSAGE:
      return {
        ...state,
        isSnackMessage: false
      };

    case AUTH_LOGOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
